import { AnimatePresence } from 'motion/react';
import React, { Activity, FC } from 'react';
import { useMeasure } from 'react-use';

import { dimmerAnimation } from '../../animation/dimmerAnimation';

import $Content from './Collapse.styles';

interface CollapseProps {
  isOpen: boolean;
  couldUnmountIfClosed?: boolean;
}

const Collapse: FC<React.PropsWithChildren<CollapseProps>> = ({
  children,
  isOpen = false,
  couldUnmountIfClosed = false,
}) => {
  const [ref, { height }] = useMeasure<HTMLDivElement>();

  if (couldUnmountIfClosed) {
    return (
      <AnimatePresence>
        {isOpen && (
          <$Content
            $height={height}
            data-testid="CollapseContent"
            {...dimmerAnimation}
          >
            <div ref={ref}>{children}</div>
          </$Content>
        )}
      </AnimatePresence>
    );
  }

  return (
    <Activity mode={isOpen ? 'visible' : 'hidden'}>
      <$Content $height={height} data-testid="CollapseContent">
        <div ref={ref}>{children}</div>
      </$Content>
    </Activity>
  );
};

export default Collapse;
